import React, { useEffect, useState } from 'react'
import Sidebar from '../../Common/Sidebar/Sidebar';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import { Markup } from 'interweave';
import '../globalStyle.css';
import { FaEdit } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";
import Modal from "react-modal";
import { toast } from 'react-toastify';
import EditKitab from './EditKitab';

//customStyles for model
const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      
    },
  };

  ///data table related
const ExpandedComponent = ({ data }) =><>
 
    {data.description ? <>
	<h5 className="text-center">Description</h5>
	    <Markup content={data.description} className="text-center"/>
	</>
	:<> 
	<h5 className="text-center">Pdf Url</h5>
	<span className="text-center">{data.pdfUrl}</span>
	</>}
     
 </>;

const FilterComponent = ({ filterText, onFilter, onClear }) => (
	<div className="d-flex">
		<input
			id="search"
            className="form-control dataTableSearch"
			type="text"
			placeholder="Filter By Kitab Name"
			aria-label="Search Input"
			value={filterText}
			onChange={onFilter}
		/>
		<button className="btn btn-primary" type="button" onClick={onClear}>
			X
		</button>
	</div>
);


export default function SeeAllKitab() {
    const [filterText, setFilterText] = React.useState('');
	const [edit, setEdit] = useState(false);
    const [editKitabInfo, setEditKitabInfo] = useState({});
    const [kitabList, setKitabList] = useState([]);
	const [deletePopUP, setDeletePopUP] = useState(false);
    const [deleteId, setDeleteId] = useState();

	const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);

   //get all kitab 
    useEffect(()  => {     
        async function fetchData() {   
         const kitab = await axios.get(`https://ahlehaqserver.herokuapp.com/api/kitab`)
         setKitabList(kitab.data.response);
        }
        fetchData(); 
      },[edit])

	  //edit function
	  const handleEdit = (e) => {
        setEditKitabInfo(e);
        setEdit(true);
      };

	  //kitab delete function 
	  const deleteConfirmation = (e) => {
		setDeletePopUP(true);
		setDeleteId(e);
	  };
	
	  const deleteKitab = async (e) => {
		try {
		  //
		  axios
			.delete(`https://ahlehaqserver.herokuapp.com/api/kitab/${e}`)
			.then((res) => console.log(res));
	
		  const filtered = kitabList.filter((k) => k._id !== e);
		  setKitabList(filtered);
		  toast.success("Kitab deleted successfully!");
		  setDeletePopUP(false);
		} catch (error) {
		  console.log(error);
		}
	  };

	  //data table related functions
	  const columns = [
		{
			name: 'Kitab Name',
			selector: row => row.kitabName,
			sortable: true,
		},
		{
			name: 'Chapter',
			selector: row => row.chapter,
			sortable: true,
		},
		{
			cell: (row) => 	<>
				<span
				onClick={() => handleEdit(row)}
				style={{ cursor: "pointer" }}
				>
				{" "}
					<FaEdit />{" "}
				</span>
				<span
				onClick={() => deleteConfirmation(row._id)}
				style={{ cursor: "pointer" }}
				className="ml-2"
				>
			    	<RiDeleteBin6Line />
				</span>
			</>,
			allowOverflow: true,
			button: true,
			width: '56px',
		},
		// <HiOutlineDotsVertical />
	];


	const filteredItems = kitabList.filter(
		item => item.kitabName && item.kitabName.toLowerCase().includes(filterText.toLowerCase()),
	);

	const subHeaderComponentMemo = React.useMemo(() => {
		const handleClear = () => {
			if (filterText) {
				setResetPaginationToggle(!resetPaginationToggle);
				setFilterText('');
			}
		};

		return (
			<div className="row">
				<div className="col-md-12 ">
			     	<FilterComponent onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />
				</div>
			</div>
		);
	}, [filterText, resetPaginationToggle]);

    return (
        <div>
	{edit && (
        <EditKitab
          setEdit={setEdit}
          editKitabInfo={editKitabInfo}
          edit={edit}
        />
      )}
        <div>
            <div className="row">
                <div className="col-md-3">
                    <Sidebar/>
                </div>
                <div className="col-md-9">
                <DataTable
                    title="See all kitab"
                    columns={columns}
                    data={filteredItems}
                     expandableRows
                    expandableRowsComponent={ExpandedComponent}
                    pagination
                    paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
                    subHeader
                    subHeaderComponent={subHeaderComponentMemo}
                    persistTableHead
					fixedHeader
					fixedHeaderScrollHeight="500px"
					highlightOnHover
                />
                </div>
            </div> 
            </div>
			<Modal isOpen={deletePopUP} style={customStyles}>
                <div className="p-3">
                <p className="font-weight-bold text-center">Are you sure?</p>
                <div className="row justify-content-between">
                    <div className="col-5">
                    <button
                        className="btn btn-danger rounded-pill px-4"
                        onClick={() => deleteKitab(deleteId)}
                    >
                        Yes
                    </button>
                    </div>
                    <div className="col-5 mr-3">
                    <button
                        className="btn btn-success rounded-pill px-3"
                        onClick={() => setDeletePopUP(false)}
                    >
                        Cancel
                    </button>
                    </div>
                </div>
                </div>
            </Modal>
        </div>
    )
}
